// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_DefaultsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { SetupFee_DefaultRow } from './SetupFee_DefaultRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SetupFee_DefaultsResponseDados {
defaults: SetupFee_DefaultRow[]
}

export type SetupFee_DefaultsResponse = ApiResponse<SetupFee_DefaultsResponseDados>;

registerResponseContract('SetupFee_DefaultsResponse', {
  defaults: {
    type: 'array',
    required: true,
    items: {
      id:                                     { type: 'number',  required: false },
      currency:                               { type: 'string',  required: true },
      provider_code:                          { type: 'string',  required: true },
      amount_cents:                           { type: 'number',  required: true },
      max_installments:                       { type: 'number',  required: true },
      countries:                              { type: 'array',   required: false },
      max_installments_by_country:            { type: 'object',  required: false },
      configured_max_installments_by_country: { type: 'object',  required: false },
      active:                                 { type: 'boolean', required: false },
    },
  },
})
